const APP_LOCALES = ['ru', 'en'];
export const CHAT_TYPES = ['private', 'group', 'supergroup', 'channel'];
export const MEMBERSHIP_ROLES = ['owner', 'admin', 'moderator', 'viewer'];
/** How a chat member was first discovered (Telegram Bot API has no full member list). */
export const MEMBERSHIP_DISCOVERY_SOURCES = [
    'message',
    'join',
    'chat_member',
    'bot_added',
    'admin_sync',
    'onboarding',
    'manual',
    'bulk_export',
];
export const PERMISSIONS = [
    'reminders:read',
    'reminders:write',
    'reminders:delete',
    'chats:read',
    'chats:manage',
    'members:read',
    'members:manage',
    'settings:read',
    'settings:write',
    'audit:read',
];
export const REMINDER_TYPES = ['birthday', 'work', 'custom', 'task'];
export const REMINDER_STATUSES = ['draft', 'active', 'paused', 'inactive', 'archived'];
export const SCHEDULING_ERROR_CODES = [
    'once_in_past',
    'period_ended',
    'no_future_run',
    'invalid_schedule',
    'missing_schedule',
];
export const SCHEDULE_TYPES = [
    'once',
    'daily',
    'weekly',
    'monthly',
    'bimonthly',
    'quarterly',
    'semiannual',
    'yearly',
    'interval',
];
export const DELIVERY_STATUSES = ['pending', 'sent', 'failed', 'cancelled'];
/** Max visible label length for ASCII tg://time links in Telegram rich messages. */
export const TELEGRAM_RICH_DATE_TIME_LABEL_MAX = 31;
/** Telegram rich-message limit for photos/videos/audio in one message. */
export const TELEGRAM_RICH_MEDIA_MAX = 50;
export const REMINDER_MEDIA_MAX_BYTES = 10 * 1024 * 1024;
export const REMINDER_MEDIA_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const REMINDER_COLLAGE_MAX_ITEMS = 10;
/** Telegram Bot API photo caption limit. */
export const REMINDER_MEDIA_CAPTION_MAX = 1024;
/** Stricter limit when label contains non-ASCII characters (e.g. Cyrillic). */
export const TELEGRAM_RICH_DATE_TIME_LABEL_MAX_UNICODE = 12;
/** Queue / schedule visibility for reminder admin UI. */
const SCHEDULING_HEALTH_STATUSES = [
    'not_applicable',
    'scheduled',
    'due_no_job',
    'misconfigured',
    'awaiting_activation',
];
export const AUDIT_ACTIONS = [
    'reminder.created',
    'reminder.updated',
    'reminder.schedule.updated',
    'reminder.deleted',
    'reminder.paused',
    'reminder.resumed',
    'reminder.archived',
    'chat.connected',
    'chat.disconnected',
    'member.role_changed',
    'delivery.sent',
    'delivery.failed',
    'delivery.permanent_error',
    'integration.telegram_api.saved',
    'integration.telegram_api.removed',
    'integration.telegram_api.verified',
];
export const TELEGRAM_API_INSTALLATION_SCOPE = 'installation';
export const ROLE_PERMISSIONS = {
    owner: PERMISSIONS,
    admin: [
        'reminders:read',
        'reminders:write',
        'reminders:delete',
        'chats:read',
        'chats:manage',
        'members:read',
        'members:manage',
        'settings:read',
        'settings:write',
        'audit:read',
    ],
    moderator: ['reminders:read', 'reminders:write', 'chats:read', 'members:read', 'settings:read'],
    viewer: ['reminders:read', 'chats:read', 'members:read', 'settings:read'],
};
//# sourceMappingURL=constants.js.map